/**
 * The travel per-diem bands and the weekly rotation, for the Job Info form.
 *
 * ⚠️ THIS IS A SECOND COPY. The source of truth is
 * `apps/api/src/common/travel-band.ts`; there is no shared package between the
 * two workspaces and the web has never imported from the API. `travelBand.spec.ts`
 * reads that file from disk and fails if the two lists diverge, which is the only
 * mitigation available short of a package split.
 *
 * The database is the real enforcement either way — `CK_projects_travel_band`
 * and `CK_projects_per_diem_days` reject anything else, whatever a client sends.
 */

export const TRAVEL_BANDS = ['0-45', '46-75', '76-120', '121-500', '501+'] as const;

export type TravelBand = (typeof TRAVEL_BANDS)[number];

export const TRAVEL_ROTATIONS = [5, 7] as const;

/**
 * Human label for a rotation.
 *
 * ⚠️ Stored in a column called `per_diem_days`, which is a misnomer: it is NOT a
 * count of per-diem days. Eligible days are a per-person judgement that belongs
 * to payroll (handbook item 2). The old UI read "Per diem — 7 days", which says
 * seven days of per diem and means "the crew stays out over the weekend".
 */
export function travelRotationLabel(days: number | null | undefined): string | null {
  if (days === 5) return '5 day (home at weekends)';
  if (days === 7) return '7 day (stays out)';
  return null;
}
